import React from 'react'

import s from './styles.module.scss'

import { SeasonPriceModeEnum } from './SeasonPriceModeEnum'
import TagPrice from '../../tag-price/TagPrice'
import {
  PriceObjectOutputDto,
  ServiceProvisionUnitEnum,
} from '../../../../../../../../lib/graphql'
import { decimalPrice } from '../../../../../../../../utils'
import { useCurrencyAreaContext } from '../../../../../../../contexts'

const SeasonPrice = ({
  mode,
  priceObject,
}: {
  mode: SeasonPriceModeEnum
  priceObject?: PriceObjectOutputDto
}) => {
  const { currency } = useCurrencyAreaContext()

  if (mode === SeasonPriceModeEnum.TAG_PRICE) {
    if (priceObject === undefined) {
      return <span className={s.priceUndefined}>n/a</span>
    }
    return (
      <TagPrice
        priceObject={priceObject}
        unit={ServiceProvisionUnitEnum.INDIVIDUAL}
      />
    )
  } else {
    return (
      <div className={s.totalSeasonPrices}>
        <span>
          {priceObject?.basePrice?.priceWithoutVat ? (
            decimalPrice(priceObject?.basePrice?.priceWithoutVat, { currency })
          ) : (
            <span className={s.priceUndefined}>n/a</span>
          )}
        </span>
        <span>
          {priceObject?.basePrice?.priceWithVat ? (
            decimalPrice(priceObject?.basePrice?.priceWithVat, { currency })
          ) : (
            <span className={s.priceUndefined}>n/a</span>
          )}
        </span>
      </div>
    )
  }
}

export default SeasonPrice
